<template>
  <div class="body_show" v-if="body_show">
    <div class="men_detail">
      <img src="@a/ceping83/ceping83_details.png" alt="" />
    </div>
    <div class="men_foots">
      <router-link :to="{path:'/ceping83_report',query:$route.query}" v-if="data.report">查看报告</router-link>
      <router-link :to="{path:'/ceping83',query:$route.query}" v-else>进入测评</router-link>
    </div>
  </div>
</template>
<script>
import {
  ceping83_detail,
  ceping_event,
} from "@/api/measurement";
import {
  queryString
} from "@/utils/tools";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        headImg: "",
        picture: "",
        data: {},
        body_show: false,
        subscribe: false,
        cids: "",
        card_show: false,
        link: "",
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
      }
    },
    methods: {
      pullData() {
        let cid = this.$route.query.cid;
        ceping83_detail()
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
            this.type_obj.evaluation_id = data.cid;          
            this.type_obj.evaluation_name = data.headtitle;          
            this.type_obj.evaluation_user_id = data.uid;          
            this.type_obj.nickname = data.nickname;          
            this.type_obj.path = this.$route.path;       
            shareCon("ceping83", this, this.type_obj);

            ceping_event({ lead_sid: this.$route.query.lead_sid,
              cid: data.cid,
              event: 'ViewDetails',
            }).then(res=>{
              // 页面访问统计
            });
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.body_show {
  // padding-bottom: 198px;
  background-color: #ffeacf;
}

.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: 98px;
  line-height: 98px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #e85239;
  z-index: 2;
  color: #fff;
  font-size: 34px;
  a {
    display: block;
    width: 100%;
    height: 100%;
    color: #fff
  }
}
</style>
